import { ENDPOINT_REQUEST, sendMsg, SERVICES_REQUEST } from "../../configurations";

export const forumServices = {
    getPostsService,
    postArticleService,
    attachFileToPostService,
    getCommentsPerPostService,
    writeCommentService,
    getRepliesPerCommentService,
    toggleFlagService,
    searchSystemService
}

function getPostsService(params, callback) {
    sendMsg(SERVICES_REQUEST.WIN_VEST, ENDPOINT_REQUEST.wFORUM.USER_ACTIVITY_STREAM.format(params.id), params).get(res => {
        callback(res);
    })
}

function postArticleService(params, callback) {
    sendMsg(SERVICES_REQUEST.WIN_VEST, ENDPOINT_REQUEST.wFORUM.POST_ARTICLE, params).post(res => {
        callback(res);
    })
}

function attachFileToPostService(params, callback) {
    sendMsg(SERVICES_REQUEST.WIN_VEST, ENDPOINT_REQUEST.wFORUM.ATTACH_FILE_TO_POST.format(params.nid), params).post(res => {
        callback(res);
    })
}

function getCommentsPerPostService(params, callback) {
    sendMsg(SERVICES_REQUEST.WIN_VEST, ENDPOINT_REQUEST.wFORUM.GET_COMMENTS_PER_POST.format(params.nid), params).get(res => {
        callback(res);
    })
}

function writeCommentService(params, callback) {
    sendMsg(SERVICES_REQUEST.WIN_VEST, ENDPOINT_REQUEST.wFORUM.WRITE_COMMENT.format(params.nid), params).post(res => {
        callback(res);
    })
}

function getRepliesPerCommentService(params, callback) {
    sendMsg(SERVICES_REQUEST.WIN_VEST, ENDPOINT_REQUEST.wFORUM.GET_REPLIES_PER_COMMENT.format(params.cid), params).get(res => {
        callback(res);
    })
}

function toggleFlagService(params, callback) {
    sendMsg(SERVICES_REQUEST.WIN_VEST, ENDPOINT_REQUEST.wFORUM.FLAG_TOGGLE.format(params.name), params).post(res => {
        callback(res);
    })
}

function searchSystemService(params, callback) {
    sendMsg(SERVICES_REQUEST.WIN_VEST, ENDPOINT_REQUEST.wFORUM.SEARCH_SYSTEM, params).get(res => {
      callback(res)
    })
  }